export default "__VITE_ASSET__Diyix_7c__"